import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteInsurance($id: ID!) {
        deleteInsurance(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
